module.exports = "/assets/data/281a661ff0efac5c25fe2fed0fe33b25-BS35.data.json";